<template>
  <div class="footer">
    <div class="row item bank" @click="changePage('bank')" v-if="page === 'form'">
      <div class="column column-25 image">
        <img :src="require('@/assets/bank.png')" />
      </div>
      <div class="column column-75 details" v-html="labels['bankButton']">
      </div>
    </div>
    <div class="row item card" @click="changePage('form')" v-if="page === 'bank' || page === 'unsubscribe' || page === 'changeSubscription'">
      <div class="column column-25 image">
        <img :src="require('@/assets/card.png')" />
      </div>
      <div class="column column-75 details" v-html="labels['donateOnlineButton']">
      </div>
    </div>
    <div class="row item card" @click="changePage('unsubscribe')">
      <div class="column column-25 image">
        <img :src="require('@/assets/card.png')" />
      </div>
      <div class="column column-75 details">
        <div class="title">Настройки подписки</div>
        <small class="description">Отписаться</small>
      </div>
    </div>
    <div class="row item card" @click="changePage('changeSubscription')">
      <div class="column column-25 image">
        <img :src="require('@/assets/card.png')" />
      </div>
      <div class="column column-75 details">
        <div class="title">Изменить сумму</div>
        <small class="description">Поменять сумму подписки</small>
      </div>
    </div>
    <a :href="reports" target="_blank" class="row item reports">
      <div class="column column-25 image">
        <img :src="require('@/assets/reports.png')" />
      </div>
      <div class="column column-75 details" v-html="labels['reportsButton']">
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  props: ['page'],
  computed: mapState({
    reports: state => state.reports,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    changePage: function (page) {
      this.$emit('switchPage', page)
    }
  }
}
</script>

<style scoped>
  .oi-donation-form .footer .item {
    flex-direction: row;
    cursor: pointer;
  }
  .oi-donation-form .footer .item .image {
    text-align: center;
    align-self: flex-end;
  }
  .oi-donation-form .footer .item .details {
    font-size: small;
  }
  .oi-donation-form .footer .item.bank img {
    height: 30px;
  }
  .oi-donation-form .footer .item.card {
    margin-top: 10px;
  }
  .oi-donation-form .footer .item.card img {
    height: 24px;
  }
  .oi-donation-form .footer .item.reports {
    color: inherit;
    margin-top: 10px;
  }
  .oi-donation-form .footer .item.reports img {
    height: 40px;
  }
</style>
